import Vue from 'vue';
import Vuetify, { VApp, VFooter, VCard, VBtn, VIcon, VImg } from 'vuetify/lib';

Vue.use(Vuetify, {
  iconfont: 'md',
  components: {
    VApp, VFooter, VCard, VBtn, VIcon, VImg
  },
  theme: {
    primary: "#97C93C"
  }
});
